/**
 * Tooltip — §7.16, on `@radix-ui/react-tooltip` (mission 6 WP03 T021; FR-005,
 * FR-027; DM-01M3C4XR0TYMTDR6BNEBZBQGXF).
 *
 * Tooltips are for disabled reasons only (§7.1): the reason is also wired to
 * `aria-describedby` by the caller (`Button`'s `disabledReason` does both).
 * navy-950, white 12/400, padding 6px 8px, radius-sm, max 280px, a 6px arrow,
 * 200ms delay. Opens on hover after the delay and at once on focus.
 *
 * `Tooltip` carries its own provider, so a tooltip works anywhere without an
 * app-level wrapper; `TooltipProvider` is exported for a region that wants to
 * share one (skip-delay between neighbours).
 */
import * as React from 'react'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'

import { cn } from './cn'

export const TOOLTIP_DELAY_MS = 200

export function TooltipProvider({
  delayDuration = TOOLTIP_DELAY_MS,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return <TooltipPrimitive.Provider delayDuration={delayDuration} {...props} />
}

export function Tooltip(props: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root {...props} />
    </TooltipProvider>
  )
}

export const TooltipTrigger = TooltipPrimitive.Trigger

export const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 6, children, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn('z-50 max-w-[280px] rounded-sm bg-navy-950 px-2 py-1.5 text-caption text-white', className)}
      {...props}
    >
      {children}
      <TooltipPrimitive.Arrow width={12} height={6} className="fill-navy-950" />
    </TooltipPrimitive.Content>
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = 'TooltipContent'
